export default __webpack_public_path__ + "static/images/lower-cost.9ac05ca0.png";